import {ArrowLeft} from 'lucide-react'
import {useNavigate} from 'react-router-dom'
import {Button} from '@/components/ui/button'
import {useI18n} from '@/i18n'
import {cn} from '@/lib/utils'

interface PageBackButtonProps {
    to?: string
    className?: string
    onClick?: () => void
}

export function PageBackButton({to, className, onClick}: PageBackButtonProps) {
    const navigate = useNavigate()
    const i18n = useI18n()

    return (
        <Button
            data-testid="btn-back"
            variant="ghost"
            size="sm"
            onClick={() => {
                if (onClick) {
                    onClick()
                } else if (to) {
                    navigate(to)
                } else {
                    navigate(-1)
                }
            }}
            className={cn('mb-6', className)}
        >
            <ArrowLeft className="h-4 w-4 mr-2"/>
            {i18n.common.back}
        </Button>
    )
}
